import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Tell us what happened",
    desc: "Two minutes, plain English. Who owes you, how much, and why.",
  },
  {
    n: "02",
    title: "Your NLL Agent takes over",
    desc: "We draft the letter, mail it certified, and set the deadline.",
  },
  {
    n: "03",
    title: "Pressure until they pay",
    desc: "Follow-ups, a Final Notice, and tap-to-file in court if needed.",
  },
];

export const HowItWorks = () => (
  <section id="how" className="py-16 sm:py-24 bg-[#F3F4F6]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.5 }}
        className="flex items-center gap-4 mb-12"
      >
        <span className="h-[3px] w-14 bg-[#2563EB]" />
        <span className="text-xs font-bold tracking-[0.35em] uppercase text-[#71717a]">
          How It Works
        </span>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-10 md:gap-8">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className="group"
          >
            <p className="font-display font-semibold text-6xl text-[#111827]/10 group-hover:text-[#2563EB] transition-colors duration-500 leading-none mb-5">
              {s.n}
            </p>
            <h3 className="font-display font-semibold text-2xl text-[#111827] mb-3">
              {s.title}
            </h3>
            <p className="text-base text-[#52525B] leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
